import React from 'react';
import './ViewModeToggle.css';

/**
 * Segmented Cards / List control. Parent owns mode state (persisted per user
 * via useViewMode / server preferences).
 */
export default function ViewModeToggle({ mode, onChange, className = '' }) {
  return (
    <div
      className={`view-mode-toggle ${className}`.trim()}
      role="group"
      aria-label="Display layout"
    >
      <button
        type="button"
        className={`view-mode-btn ${mode === 'cards' ? 'active' : ''}`}
        onClick={() => onChange('cards')}
        aria-pressed={mode === 'cards'}
      >
        Cards
      </button>
      <button
        type="button"
        className={`view-mode-btn ${mode === 'list' ? 'active' : ''}`}
        onClick={() => onChange('list')}
        aria-pressed={mode === 'list'}
      >
        List
      </button>
    </div>
  );
}
